<template>
  <div class="home">
    <van-nav-bar
      :title="
        type == 'shop' ? $t('EditShop.title') : $t('EditShop.storeSetting')
      "
      left-arrow
      fixed
      @click-left="$router.push('/ShopSet/' + sessionStorage.actShopId)"
    >
      <!-- <van-icon
        name="./static/img/ok.png"
        slot="right"
        @click="patchShop()"
        style="font-size: 24px"
      /> -->
      <van-button
        type="primary"
        color="#1989fa"
        @click="patchShop()"
        slot="right"
        >{{ $t("PackageDish.save") }}</van-button
      >
    </van-nav-bar>

    <van-cell-group>
      <template v-if="type == 'shop'">
        <!-- 店铺类型 -->
        <van-field
          v-model="cateShop"
          left-icon="static/img/shopleixing.png"
          :label="$t('NewShop.shopType')"
          :placeholder="$t('NewShop.chooseShopType')"
          readonly
          right-icon="arrow"
          @click="showCategory = true"
        />
        <van-popup v-model="showCategory" position="bottom">
          <van-picker
            show-toolbar
            :columns="shopCategory"
            @cancel="showCategory = false"
            @confirm="omConfirmCategory"
            :confirm-button-text="$t('vantText.confirm')"
            :cancel-button-text="$t('vantText.cancel')"
          />
        </van-popup>
        <!-- 名称 -->
        <van-field
          v-model="shop.name"
          left-icon="static/img/shopname.png"
          :label="$t('EditShop.name')"
          clearable
          :placeholder="$t('EditShop.inputName')"
        />
        <!-- 地址 -->
        <van-field
          type="textarea"
          v-model="shop.address"
          left-icon="./static/img/local.png"
          :label="$t('EditShop.address')"
          clearable
          :placeholder="$t('EditShop.inputAddress')"
        />
        <!-- 图片 -->
        <van-cell
          :title="$t('EditShop.pic')"
          icon="./static/img/image.png"
          title-style="width: 110px;flex:none;"
        >
          <van-uploader :after-read="afterRead" v-model="imgs" :max-count="1">
          </van-uploader>
        </van-cell>
        <!-- 广告图片 -->
        <van-cell
          :title="$t('EditShop.advertising_images')"
          icon="./static/img/image.png"
          title-style="width: 110px;flex:none;"
        >
          <van-uploader
            :after-read="bannerAfterRead"
            @delete="deletePhoto"
            v-model="banner"
            :max-count="3"
          >
          </van-uploader>
        </van-cell>
        <!-- 電話 -->
        <van-field
          v-model="shop.phone"
          left-icon="./static/img/tele.png"
          :label="$t('EditShop.phone')"
          clearable
          :placeholder="$t('EditShop.inputPhone')"
        />
        <!-- 开始营业时间 -->
        <van-field
          readonly
          v-model="shop.start_time"
          right-icon="arrow"
          :label="$t('EditShop.startTime')"
          :placeholder="$t('EditShop.chooseStartTime')"
          left-icon="./static/img/Business_time.png"
          @click="startTimePicker = true"
        />
        <van-popup v-model="startTimePicker" position="bottom">
          <van-datetime-picker
            v-model="shop.start_time"
            type="time"
            :min-hour="0"
            :confirm-button-text="$t('vantText.confirm')"
            :cancel-button-text="$t('vantText.cancel')"
            @cancel="startTimePicker = false"
            @confirm="onConfirmStartTime"
          />
        </van-popup>
        <!-- 午休开始时间 -->
        <van-field
          readonly
          v-model="shop.after_start"
          :label="$t('EditShop.startAfterTime')"
          :placeholder="$t('EditShop.chooseStartAfterTime')"
          left-icon="./static/img/Business_time.png"
          @click.stop="afterStartPicker = true"
        >
          <template slot="button">
            <van-icon
              v-if="shop.after_start"
              name="clear"
              @click.stop="handleClearStartTime"
            />
            <van-icon name="arrow" @click.stop="afterStartPicker = true" />
          </template>
        </van-field>
        <van-popup v-model="afterStartPicker" position="bottom">
          <van-datetime-picker
            v-model="shop.after_start"
            type="time"
            :min-hour="0"
            :confirm-button-text="$t('vantText.confirm')"
            :cancel-button-text="$t('vantText.cancel')"
            @cancel="afterStartPicker = false"
            @confirm="onConfirmAfterStart"
          />
        </van-popup>
        <!-- 午休结束时间 -->
        <van-field
          readonly
          v-model="shop.after_end"
          :label="$t('EditShop.endAfterTime')"
          :placeholder="$t('EditShop.chooseEndAfterTime')"
          left-icon="./static/img/Business_time.png"
          @click.stop="afterEndPicker = true"
        >
          <template slot="button">
            <van-icon
              v-if="shop.after_end"
              name="clear"
              @click.stop="handleClearEndTime"
            />
            <van-icon name="arrow" @click.stop="afterEndPicker = true" />
          </template>
        </van-field>
        <van-popup v-model="afterEndPicker" position="bottom">
          <van-datetime-picker
            v-model="shop.after_end"
            type="time"
            :min-hour="0"
            :confirm-button-text="$t('vantText.confirm')"
            :cancel-button-text="$t('vantText.cancel')"
            @cancel="afterEndPicker = false"
            @confirm="onConfirmAfterEnd"
          />
        </van-popup>
        <!-- 结束营业时间 -->
        <van-field
          readonly
          v-model="shop.end_time"
          right-icon="arrow"
          :label="$t('EditShop.endTime')"
          :placeholder="$t('EditShop.chooseEndTime')"
          left-icon="./static/img/Business_time.png"
          @click="endTimePicker = true"
        />
        <van-popup v-model="endTimePicker" position="bottom">
          <van-datetime-picker
            v-model="shop.end_time"
            type="time"
            :min-hour="0"
            :confirm-button-text="$t('vantText.confirm')"
            :cancel-button-text="$t('vantText.cancel')"
            @cancel="endTimePicker = false"
            @confirm="onConfirmEndTime"
          />
        </van-popup>
        <!-- 服务时限 -->
        <van-field
          readonly
          clickable
          left-icon="./static/img/cook_speed.png"
          right-icon="arrow"
          :label="$t('EditShop.cookTime')"
          :value="shop.set_time + $t('EditShop.minute')"
          :placeholder="$t('EditShop.cookingTime')"
          @click="showSetTimePicker = true"
        />
        <!-- 介绍 -->
        <van-field
          v-model="shop.intro"
          type="textarea"
          autosize
          clickable
          left-icon="./static/img/introduction.png"
          :label="$t('EditShop.intro')"
          :placeholder="$t('EditShop.inputIntro')"
        />
        <van-popup v-model="showSetTimePicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="cookTimes"
            :confirm-button-text="$t('vantText.confirm')"
            :cancel-button-text="$t('vantText.cancel')"
            @cancel="showSetTimePicker = false"
            @confirm="onConfirm"
          />
        </van-popup>
        <!-- 語言選擇 -->
        <van-field
          :label="$t('EditShop.chooseL')"
          @click="showLanguage = true"
          :placeholder="$t('center.chooseLang')"
          v-model="lang"
          left-icon="./static/img/yuyan.png"
          is-link
        ></van-field>
        <!-- 語言選擇 -->
        <van-popup v-model="showLanguage" position="bottom">
          <van-picker
            show-toolbar
            :columns="language"
            :confirm-button-text="$t('vantText.confirm')"
            :cancel-button-text="$t('vantText.cancel')"
            @cancel="showLanguage = false"
            @confirm="getLang"
          />
        </van-popup>

        <!-- 货币选择 -->
        <van-field
          :label="$t('EditShop.currency')"
          @click="showcurrency = true"
          :placeholder="$t('EditShop.chooseCurrency')"
          v-model="currencyVal"
          left-icon="./static/img/yuyan.png"
          is-link
        ></van-field>
        <van-popup v-model="showcurrency" position="bottom">
          <van-picker
            show-toolbar
            :columns="currency"
            :confirm-button-text="$t('vantText.confirm')"
            :cancel-button-text="$t('vantText.cancel')"
            @cancel="showcurrency = false"
            @confirm="onConfirmCurrency"
          />
        </van-popup>

        <!-- 颜色选择 -->
        <van-field
          :label="$t('EditShop.color')"
          class="colorSelect"
          @click="showcolor = true"
          :placeholder="$t('EditShop.inputColor')"
          v-model="colorVal"
          left-icon="./static/img/yuyan.png"
          is-link
        ></van-field>
        <div v-if="showcolor" class="selectColor">
          <sketch-picker v-model="colors" />
          <div class="selectColor_footer">
            <van-button type="info" @click="selectColorBtn">
              <van-icon name="success" />
            </van-button>
            <van-button color="#FF9900" @click="showcolor = false">
              <van-icon name="cross" />
            </van-button>
          </div>
        </div>
        <!-- <van-popup v-model="showcolor" position="bottom">
          <van-picker
            show-toolbar
            :columns="colorData"
            :confirm-button-text="$t('vantText.confirm')"
            :cancel-button-text="$t('vantText.cancel')"
            @cancel="showcolor = false"
            @confirm="onConfirmColor"
          />
        </van-popup> -->
      </template>
      <!-- 功能设定 -->
      <template v-else-if="type == 'settings'">
        <!-- 是否营业 -->
        <van-cell :title="$t('ShopSet.IsItOpen')">
          <van-switch
            v-model="is_open"
            @input="changeIsItOpen"
            active-color="#2f75f7"
            inactive-color="#ee0a24"
          />
        </van-cell>
        <!--税费-->
        <van-cell>
          <template #title>
            <span class="custom-title">{{ $t("tax.name") }}</span>
            <span style="margin-left:20px">
              <van-button type="primary" @click="addBtn">{{
                $t("tax.add")
              }}</van-button>
            </span>
            <span style="margin-left:20px">
              <van-button type="danger" @click="deleteShowBtn">{{
                $t("tax.delete")
              }}</van-button>
            </span>
          </template>
        </van-cell>
        <van-cell class="TaxBox" v-for="(item, index) in taxsList" :key="index">
          <van-field
            input-align="center"
            v-if="isAdditional"
            class="taxInput"
            v-model="item.price"
            type="digit"
            :placeholder="$t('tax.PleaseTaxPrice')"
            autosize
            @blur="changeTaxBtn(item)"
          >
            <template #extra>
              <van-switch
                v-model="item.status"
                @click="changeTaxBtn(item, index)"
              />
              <img
                v-if="deleteShow"
                @click="deleteTax(item.id)"
                style="width: 22px;height: 33px;margin-left:10px"
                src="../../static/img/Trash_s.png"
                alt=""
                srcset=""
              />
            </template>
            <template #right-icon>(%)</template>
            <template #label>
              <van-field
                v-if="isAdditional"
                class="taxName"
                v-model="item.name"
                rows="1"
                type="textarea"
                autosize
                placeholder="$t('tax.PleaseTaxName')"
                @blur="changeTaxBtn(item, index)"
              >
              </van-field>
            </template>
          </van-field>
        </van-cell>
        <!-- 快捷点菜开关 -->
        <van-cell :title="$t('EditShop.isQuick')">
          <van-switch
            v-model="is_quick"
            @input="changeQuickSet"
            active-color="#2f75f7"
            inactive-color="#ee0a24"
          />
        </van-cell>

        <!-- 服务费开关 -->
        <van-cell :title="$t('EditShop.isServiceCharge')">
          <van-switch
            v-model="service"
            @input="changeServiceSet"
            active-color="#2f75f7"
            inactive-color="#ee0a24"
          />
        </van-cell>
        <!-- 服务费百分比 -->
        <van-field
          v-if="service"
          v-model="shop.service_charge"
          :label="$t('EditShop.serviceCharge') + '(%)'"
          type="digit"
          clearable
          :placeholder="$t('EditShop.serviceCharge')"
        />
        <!-- 折扣费开关 -->
        <van-cell :title="$t('EditShop.isDiscountFee')">
          <van-switch
            v-model="discount"
            @input="changeDiscountSet"
            active-color="#2f75f7"
            inactive-color="#ee0a24"
          />
        </van-cell>
        <!-- 是否跳過選人數 -->
        <van-cell :title="$t('ShopSet.IsSkip')">
          <van-switch
            v-model="is_skip"
            @input="changeIsSkip"
            active-color="#2f75f7"
            inactive-color="#ee0a24"
          />
        </van-cell>
        <!-- 是否跳過外帶 -->
        <van-cell :title="$t('ShopSet.isOut')">
          <van-switch
            v-model="is_out"
            @input="changeIsOut"
            active-color="#2f75f7"
            inactive-color="#ee0a24"
          />
        </van-cell>
        <!-- 是否浮動座位點餐 -->
        <van-cell :title="$t('ShopSet.seat')">
          <van-switch
            v-model="is_seat"
            @input="changeisSeat"
            active-color="#2f75f7"
            inactive-color="#ee0a24"
          />
        </van-cell>
        <!-- 设置金额精度 -->
        <van-cell :title="$t('EditShop.isFloat')">
          <van-switch
            v-model="isFloat"
            @input="changeFloatSet"
            active-color="#2f75f7"
            inactive-color="#ee0a24"
          />
        </van-cell>
        <!-- 设置地区运费 -->
        <van-cell :title="$t('EditShop.isAdditional')">
          <van-switch
            v-model="isAdditional"
            @input="changeAddSet"
            active-color="#2f75f7"
            inactive-color="#ee0a24"
          />
        </van-cell>
        <!-- 设置订单金额多少免地区运费 -->
        <van-field
          v-if="isAdditional"
          v-model="shop.additional_charge"
          class="amountExempt"
          style="text-align: right;"
          :label="$t('EditShop.amountExempt')"
          type="digit"
          clearable
          :placeholder="$t('EditShop.amount')"
        />
        <!-- 外卖时限 -->
        <van-field
          readonly
          clickable
          left-icon="./static/img/Business_time.png"
          right-icon="arrow"
          :label="$t('EditShop.fail_time')"
          :value="shop.fail_time + $t('NewShop.hour')"
          :placeholder="$t('EditShop.inputFail_time')"
          @click="showFailTimePicker = true"
        />
        <van-popup v-model="showFailTimePicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="failTimes"
            @cancel="showFailTimePicker = false"
            @confirm="onConfirmFailTime"
            :confirm-button-text="$t('vantText.confirm')"
            :cancel-button-text="$t('vantText.cancel')"
          />
        </van-popup>

        <!-- 是否先支付 -->
        <van-cell :title="$t('ShopSet.IsPay')">
          <van-switch
            v-model="is_pay"
            @input="changeIsPay"
            active-color="#2f75f7"
            inactive-color="#ee0a24"
          />
        </van-cell>
        <!-- 是否按照订单打印 -->
        <van-cell :title="$t('ShopSet.IsMerge')">
          <van-switch
            v-model="is_merge"
            @input="changeIsMerge"
            active-color="#2f75f7"
            inactive-color="#ee0a24"
          />
        </van-cell>
        <!-- 是否开启付款结算后自动清洁座位表 -->
        <van-cell :title="$t('ShopSet.clear')">
          <van-switch
            v-model="clean"
            @input="changeClean"
            active-color="#2f75f7"
            inactive-color="#ee0a24"
          />
        </van-cell>
        <!-- 是否开启会员充值功能 -->
        <!-- <van-cell :title="$t('ShopSet.member')">
          <van-switch
            v-model="is_member"
            @input="changeIsMember"
            active-color="#2f75f7"
            inactive-color="#ee0a24"
          />
        </van-cell> -->
        <!-- 外卖是否自动打印 -->
        <van-cell :title="$t('ShopSet.auto')">
          <van-switch
            v-model="is_auto"
            @input="changeisAuto"
            active-color="#2f75f7"
            inactive-color="#ee0a24"
          />
        </van-cell>
        <!-- 设置等待时长 -->
        <van-field
          readonly
          clickable
          left-icon="./static/img/Business_time.png"
          right-icon="arrow"
          :label="$t('EditShop.fail_time')"
          :value="shop.wait_time + $t('NewShop.minute')"
          :placeholder="$t('EditShop.inputFail_time')"
          @click="showWaitTimePicker = true"
        />
        <van-popup v-model="showWaitTimePicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="waitTimes"
            @cancel="showWaitTimePicker = false"
            @confirm="onConfirmWaitTime"
            :confirm-button-text="$t('vantText.confirm')"
            :cancel-button-text="$t('vantText.cancel')"
          />
        </van-popup>
      </template>
    </van-cell-group>
  </div>
</template>

<script>
import { Sketch } from "vue-color";
export default {
  components: {
    "sketch-picker": Sketch
  },
  data() {
    return {
      shop: {
        name: "",
        address: "",
        image_id: "",
        phone: "",
        start_time: "",
        after_start: "", // 开始午休
        after_end: "", // 结束午休
        end_time: "",
        intro: "",
        set_time: "",
        language_id: "",
        type_id: "",
        currency_id: "",
        color_id: "1",
        is_quick: "",
        service: "",
        service_charge: "0",
        discount: "",
        is_accuracy: "0",
        is_additional: "0",
        is_open: "0",
        is_skip: "0",
        is_out: "0",
        is_pay: "",
        is_merge: "",
        fail_time: "0",
        additional_charge: "0",
        banner: [],
        clean: "0",
        settle: "0"
      },
      banner: [],
      is_quick: "",
      service: "",
      discount: "",
      isFloat: "",
      isAdditional: "",
      is_open: "",
      is_skip: "",
      is_out: "",
      is_pay: "",
      is_merge: "",
      is_member: "",
      is_auto: "",
      is_seat: "",
      shopCategory: [],
      img: "",
      cookTimes: [
        "10",
        "15",
        "20",
        "25",
        "30",
        "35",
        "40",
        "45",
        "50",
        "55",
        "60"
      ],
      showSetTimePicker: false,
      failTimes: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24"
      ],
      waitTimes: [5, 10, 15, 20, 25, 30],
      showFailTimePicker: false,
      showWaitTimePicker: false,
      showStartTimePicker: false,
      startTimePicker: false,
      afterStartPicker: false,
      afterEndPicker: false,
      endTimePicker: false,
      langList: [],
      showLanguage: false,
      language: [],
      lang: "",
      cateShop: "",
      showCategory: false,
      categoryList: [],
      getLangs: "",
      showcurrency: false,
      currencyVal: "",
      currency: [],
      currencyList: [],

      showcolor: false,
      colorVal: "",
      colorData: [],
      colorList: [],
      imgs: [],
      text: "",
      checked: true,
      taxShow: false,
      taxName: "",
      taxName1: "",
      taxsList: [],
      deleteShow: false,
      status: 0,
      type: "",
      clean: false,
      settle: false,
      /* 颜色选择器 */
      colors: {
        color: "",
        hex: "#000000"
        // rgba: { r: 25, g: 77, b: 51, a: 1 }
      }
    };
  },
  mounted: function() {
    this.getShop();
    this.getLangList();
    this.getCategoryList();
    this.getCurrencyList(), (this.getLangs = this.$i18n.locale);
    console.log(this.getLangs);
    this.getColorList();
    this.getTaxes();
    this.type = this.$route.params.type;
    this.shop.banner = new Array("3");
    console.log(this.shop.banner);
  },
  methods: {
    selectColorBtn() {
      this.showcolor = false;
      this.shop.colorvalue = this.colors.hex;
      this.colorVal = this.colors.hex;
      if (this.type == "shop") {
        var seldiv = document.getElementsByClassName("colorSelect");
        var dom = seldiv[0].getElementsByClassName("van-cell__value");
        dom[0].style.background = this.colorVal;
      }
    },
    getShop() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/store/" + sessionStorage.actShopId + "/show"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.shop = res.data.data;
            console.log(res.data.data, "店铺信息");
            this.lang = res.data.data.language.name_cn;
            if (res.data.data.image) {
              this.imgs.push({ url: res.data.data.image.path });
            }
            if (res.data.data.banner.length != 0) {
              res.data.data.banner.forEach(item => {
                this.banner.push({ id: item.id, url: item.path });
              });
            }
            this.shop.service_charge = parseFloat(this.shop.service_charge);
            this.is_quick = res.data.data.is_quick == "1" ? true : false;
            this.service = res.data.data.service == "1" ? true : false;
            this.discount = res.data.data.discount == "1" ? true : false;
            this.isFloat = res.data.data.is_accuracy == "1" ? true : false;
            this.isAdditional =
              res.data.data.is_additional == "1" ? true : false;
            this.is_open = res.data.data.is_open == "1" ? true : false;
            this.is_skip = res.data.data.is_skip == "1" ? true : false;
            this.is_out = res.data.data.is_out == "1" ? true : false;
            this.is_pay = res.data.data.is_pay == "1" ? true : false;
            this.is_merge = res.data.data.is_merge == "1" ? true : false;
            this.clean = res.data.data.clean == "1" ? true : false;
            this.is_member = res.data.data.is_member == "1" ? true : false;
            this.settle = res.data.data.settle == "1" ? true : false;
            this.is_auto = res.data.data.is_auto == "1" ? true : false;
            this.is_seat = res.data.data.is_seat == "1" ? true : false;
            if (this.type == "shop") {
              var seldiv = document.getElementsByClassName("colorSelect");
              var dom = seldiv[0].getElementsByClassName("van-cell__value");
              // dom[0].style.background = res.data.data.color.code;
              dom[0].style.background = res.data.data.colorvalue;
            }
            // this.colorVal = res.data.data.color.code;
            this.colorVal = res.data.data.colorvalue;
            this.colors.hex = res.data.data.colorvalue;

            if (this.getLangs == "zh") {
              this.cateShop = res.data.data.type.name_cn;
              if (res.data.data.currency !== null) {
                this.currencyVal =
                  res.data.data.currency.name_cn +
                  " " +
                  res.data.data.currency.unit;
              }
            } else if (this.getLangs == "hk") {
              this.cateShop = res.data.data.type.name_hk;
              if (res.data.data.currency !== null) {
                this.currencyVal =
                  res.data.data.currency.name_hk +
                  " " +
                  res.data.data.currency.unit;
              }
            } else if (this.getLangs == "en") {
              this.cateShop = res.data.data.type.name_en;
              if (res.data.data.currency !== null) {
                this.currencyVal =
                  res.data.data.currency.name_en +
                  " " +
                  res.data.data.currency.unit;
              }
            }
            if (res.data.data.image) {
              this.img = res.data.data.image.path;
              this.shop.image_id = res.data.data.image.id;
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            type: "fail",
            message: this.$t("EditShop.message")
          });
        });
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      // console.log("上传图片", file);
      let formData = new FormData();
      formData.append("type", "shop");
      formData.append("file", file.file);
      this.$axios({
        method: "post",
        url: this.$build + "/api/image",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + sessionStorage.token
        },
        data: formData
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.shop.image_id = res.data.success.image_id;
            this.img = res.data.success.url;
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditShop.message")
          });
        });
    },
    bannerAfterRead(file) {
      // console.log("上传图片", file);
      let formData = new FormData();
      formData.append("type", "shop");
      formData.append("file", file.file);
      this.$axios({
        method: "post",
        url: this.$build + "/api/image",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + sessionStorage.token
        },
        data: formData
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            let num = this.banner.length;
            this.banner[num - 1].id = res.data.success.image_id;
            console.log(this.banner);
            // this.banner.push({ url: res.data.data.image.path });
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditShop.message")
          });
        });
    },
    deletePhoto() {
      console.log(this.banner);
    },
    // 清除时间
    handleClearStartTime() {
      this.shop.after_start = "";
    },
    handleClearEndTime() {
      this.shop.after_end = "";
    },
    onConfirm(value, index) {
      this.shop.set_time = value;
      this.showSetTimePicker = false;
    },
    onConfirmFailTime(value, index) {
      this.shop.fail_time = value;
      this.showFailTimePicker = false;
    },
    onConfirmWaitTime(value, index) {
      console.log("触发");
      this.shop.wait_time = value;
      this.showWaitTimePicker = false;
    },
    onConfirmStartTime(value, index) {
      this.shop.start_time = value;
      this.startTimePicker = false;
    },

    onConfirmAfterStart(value, index) {
      this.shop.after_start = value;
      this.afterStartPicker = false;
    },
    onConfirmAfterEnd(value, index) {
      this.shop.after_end = value;
      this.afterEndPicker = false;
    },

    onConfirmEndTime(value, index) {
      this.shop.End_time = value;
      this.endTimePicker = false;
    },
    patchShop() {
      if (
        this.shop.name &&
        this.shop.address &&
        this.shop.phone &&
        this.shop.set_time
      ) {
        let idList = [];
        this.banner.forEach(item => {
          idList.push(item.id);
        });
        this.shop.banner_id = idList;
        console.log(this.shop);
        this.$axios({
          method: "PATCH",
          headers: {
            Authorization: "Bearer " + sessionStorage.token
          },
          url:
            this.$build + "/api/store/" + sessionStorage.actShopId + "/update",
          data: this.shop
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: res.data.message
              });
              const vm = this;
              setTimeout(function() {
                vm.$router.push("/ShopSet/" + sessionStorage.actShopId);
              }, 1000);
            } else {
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("EditShop.message")
            });
          });
      } else {
        this.$toast(this.$t("EditShop.toast"));
      }
    },
    //获取语言列表
    getLangList() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/language/index"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.langList = res.data.data;
            for (var i = 0; i < this.langList.length; i++) {
              this.language.push(this.langList[i].name_cn);
            }
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("NewShop.message")
          });
        });
    },
    // 获取店铺类型列表
    getCategoryList() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/type/index"
      })
        .then(res => {
          if (res.data.status == 200) {
            // console.log(res);
            this.categoryList = res.data.data;
            for (var i = 0; i < this.categoryList.length; i++) {
              if (this.getLangs == "zh") {
                this.shopCategory.push(this.categoryList[i].name_cn);
              } else if (this.getLangs == "hk") {
                this.shopCategory.push(this.categoryList[i].name_hk);
              } else if (this.getLangs == "en") {
                this.shopCategory.push(this.categoryList[i].name_en);
              } else {
                this.shopCategory.push(this.categoryList[i].name_en);
              }
            }
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("NewShop.message")
          });
        });
    },
    getLang(value, index) {
      this.showLanguage = false;
      console.log(this.langList);
      this.shop.language_id = this.langList[index].id;
      if (this.shop.language_id == 1) {
        this.lang = "English";
      } else if (this.shop.language_id == 2) {
        this.lang = "繁體中文";
      } else if (this.shop.language_id == 3) {
        this.lang = "简体中文";
      }
    },
    omConfirmCategory(value, index) {
      this.showCategory = false;
      this.shop.type_id = this.categoryList[index].id;
      this.cateShop = value;
    },
    // 获取货币列表
    getCurrencyList() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/currency/index"
      })
        .then(res => {
          if (res.data.status == 200) {
            this.currencyList = res.data.data;
            console.log(res.data.data);
            console.log(this.getLangs);
            for (var i = 0; i < this.currencyList.length; i++) {
              if (this.getLangs == "zh") {
                this.currency.push(
                  this.currencyList[i].name_cn + " " + this.currencyList[i].unit
                );
              } else if (this.getLangs == "hk") {
                this.currency.push(
                  this.currencyList[i].name_hk + " " + this.currencyList[i].unit
                );
              } else if (this.getLangs == "en") {
                this.currency.push(
                  this.currencyList[i].name_en + " " + this.currencyList[i].unit
                );
              } else {
                this.currency.push(
                  this.currencyList[i].name_en + " " + this.currencyList[i].unit
                );
              }
            }
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("NewShop.message")
          });
        });
    },
    changeQuickSet(is_quick) {
      this.is_quick = is_quick;
      this.shop.is_quick = is_quick ? 1 : 0;
    },
    changeServiceSet(service) {
      this.service = service;
      this.shop.service = service ? 1 : 0;
    },
    changeDiscountSet(discount) {
      this.discount = discount;
      this.shop.discount = discount ? 1 : 0;
    },
    changeFloatSet(isFloat) {
      this.isFloat = isFloat;
      this.shop.is_accuracy = isFloat ? 1 : 0;
    },
    changeAddSet(isAdditional) {
      this.isAdditional = isAdditional;
      this.shop.is_additional = isAdditional ? 1 : 0;
    },
    changeIsItOpen(is_open) {
      this.is_open = is_open;
      this.shop.is_open = is_open ? 1 : 0;
    },
    changeIsSkip(is_skip) {
      this.is_skip = is_skip;
      this.shop.is_skip = is_skip ? 1 : 0;
    },
    changeIsOut(is_out) {
      this.is_out = is_out;
      this.shop.is_out = is_out ? 1 : 0;
    },
    changeIsPay(is_pay) {
      this.is_pay = is_pay;
      this.shop.is_pay = is_pay ? 1 : 0;
    },
    changeIsMerge(is_merge) {
      this.is_merge = is_merge;
      this.shop.is_merge = is_merge ? 1 : 0;
    },
    changeClean(clean) {
      this.clean = clean;
      this.shop.clean = clean ? 1 : 0;
      this.shop.settle = clean ? 1 : 0;
    },
    changeIsMember(is_member) {
      this.is_member = is_member;
      this.shop.is_member = is_member ? 1 : 0;
    },
    changeisAuto(is_auto) {
      this.is_auto = is_auto;
      this.shop.is_auto = is_auto ? 1 : 0;
    },
    changeisSeat(is_seat) {
      this.is_seat = is_seat;
      this.shop.is_seat = is_seat ? 1 : 0;
    },
    // 确认按钮
    onConfirmCurrency(value, index) {
      this.showcurrency = false;
      console.log(value);
      this.currencyVal = value;
      this.shop.currency_id = this.currencyList[index].id;

      // 保存货币图标
      console.log(this.currencyList[index].unit);
      sessionStorage.setItem("currencyIcon", this.currencyList[index].unit);
    },
    // 获取颜色
    getColorList() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/color/index"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.colorList = res.data.data;
            for (var i = 0; i < this.colorList.length; i++) {
              this.colorData.push(
                '<span style="width:20px;height:20px;float:left;margin-right:5px;background:' +
                  this.colorList[i].code +
                  '"></span> ' +
                  this.colorList[i].code
              );
            }
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 确认按钮
    onConfirmColor(value, index) {
      this.showcolor = false;
      this.colorVal = value.substring(value.length - 7, value.length);
      console.log(this.colorVal);
      if (this.type == "shop") {
        var seldiv = document.getElementsByClassName("colorSelect");
        var dom = seldiv[0].getElementsByClassName("van-cell__value");
        dom[0].style.background = this.colorVal;
      }

      this.shop.color_id = this.colorList[index].id;
      sessionStorage.setItem("colorCode", this.colorVal);
    },
    // 获取门店税费列表
    getTaxes() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/taxes/" + sessionStorage.actShopId + "/index"
      })
        .then(res => {
          console.log(res, "获取门店税费列表");
          if (res.data.status == 200) {
            this.taxsList = res.data.data;
            this.taxsList.forEach(item => {
              if (item.status == 0) {
                item.status = false;
              } else {
                item.status = true;
              }
            });
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 创建门店税费
    createTax(name, price, status) {
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/taxes/" + sessionStorage.actShopId + "/store",
        data: {
          name: name,
          price: price,
          status: status
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });
            this.getTaxes();
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 更改门店税费
    changeTax(taxId, name, price, status) {
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/taxes/" + taxId + "/update",
        data: {
          name: name,
          price: price,
          status: status
        }
      })
        .then(res => {
          console.log(res);
          this.$toast({
            message: res.data.message
          });
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 删除门店税费
    deleteTax(taxId) {
      this.$axios({
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/taxes/" + taxId + "/destroy"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.getTaxes();
            this.$toast({
              message: res.data.message
            });
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 添加按钮
    addBtn() {
      let name = this.$t("tax.PleaseTaxName");
      let price = 0;
      let status = 0;
      this.createTax(name, price, status);
    },
    // 修改按钮
    changeTaxBtn(item) {
      if (item.status == true) {
        this.status = 0;
      } else {
        this.status = 1;
      }
      this.changeTax(item.id, item.name, item.price, this.status);
      this.getTaxes();
    },
    // 删除按钮
    deleteShowBtn() {
      if (this.deleteShow == false) {
        this.deleteShow = true;
      } else {
        this.deleteShow = false;
      }
    }
  }
};
</script>
<style scoped>
/* 开关样式 */
/* .openOrClose {
  position: absolute;
  right: 70px;
  top:3px;
  font-size: 20px;
} */
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-field__left-icon .van-icon {
  font-size: 30px;
}
/deep/ .van-cell .van-icon {
  font-size: 30px;
}
/deep/ .van-cell .van-icon-clear {
  font-size: 24px;
}
/deep/ .van-uploader__preview-delete-icon {
  top: -9px;
  right: -8px;
}
/deep/ .van-field__label {
  width: 110px;
}
/deep/ .amountExempt .van-field__label {
  width: 150px;
}
/deep/ .van-switch {
  float: right;
}
.home {
  width: 100%;
  height: 100vh;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #2f75f4;
}
/deep/ .van-image {
  font-size: 28px;
  vertical-align: top;
}
/deep/ .colorSelect .van-field__control {
  color: #fff;
  padding-left: 10px;
  line-height: 30px;
}
/deep/ .van-button {
  height: 35px;
}
.shopBottom {
  position: absolute;
  bottom: 0;
  height: 60px;
  background: #fff;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cancelBtn {
  width: 30%;
  top: 10%;
  left: 5%;
  background: #dfdede;
  font-weight: bold;
  font-size: 16px;
}
.certainBtn {
  width: 30%;
  top: 10%;
  right: 5%;
  background: linear-gradient(90deg, #ffc914, #ffb20d);
  font-weight: bold;
  font-size: 16px;
}
.van-cell__value {
  text-align: left;
}
.taxIcon .van-icon__image {
  height: 100%;
  margin-top: 0.4375rem;
}
.selectColor {
  background: #fff;
  position: absolute;
  bottom: 50px;
  right: 10px;
}
.selectColor_footer {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}
/deep/.taxInput .van-field__label {
  width: 130px;
}
/deep/.taxInput .van-field__body {
  padding: 5px;
}
/deep/.taxInput .van-field__control {
  width: 16%;
}
/deep/.taxName {
  padding: 0px;
}
/deep/.taxName .van-field__body {
  padding: 4px;
}
/deep/.taxName .van-field__control {
  width: 100%;
  height: 26px;
}
/deep/.TaxBox {
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/Shop/EditShop.vue